(ns superadmin.page.view
  (:require [common.widgets.page :as page]
            [superadmin.agency-table.view :refer [agency-data-grid]]
            [uix.core :as uix :refer [$ defui]]))

(defui superadmin-page []
  ($ page/page
     ($ page/page-header {:title "Agencies"})
     ($ page/content-padding {:sx #js {:overflow "hidden"}}
        ($ agency-data-grid))))
